import FastEvent from '../../../shared/classes/fastEvent';
import Main from '../../../shared/types/enums/main';
import MediaProduction from '../../../shared/classes/mediaProduction';
import Rail from '../../../shared/classes/rail';
import TEmpty from '../templates/empty';
import TMosaic from '../templates/mosaic/ui/mosaic';
import mediaProductionObservable from '../../../shared/api/mediaProduction/mediaProductionObservable';
import seasonObservable from '../../../shared/api/seasons/seasonObservable';
import useComplete from '@shared/components/utils/hooks/useComplete';
import { Subscription, Observer } from 'rxjs';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import { userSelector } from '../../../shared/store/slices/user.slice';
import {
  selectCurrentParams,
  updateParams,
} from '../../../shared/store/slices/router.slice';

export default function SeasonExtended() {
  const dispatch = useAppDispatch();

  const { channelsData } = useAppSelector(channelsSelector);
  const { initialized } = useAppSelector(userSelector);
  const currentParams = useAppSelector(selectCurrentParams);

  const [complete, setComplete] = useComplete();
  const [items, setItems] = useState<(FastEvent | MediaProduction)[]>(
    (currentParams?.items as MediaProduction[]) || []
  );

  useEffect(() => {
    if (complete) return;
    if (currentParams?.items) {
      setComplete(true);
      return;
    }

    let subscription: Subscription;
    if (channelsData?.length && initialized) {
      const seasonObserver: Observer<{
        data: Rail[];
        type: Main;
      }> = {
        next: (val) => {
          if (val.type === Main.RAILS) {
            const items =
              val?.data?.length && val?.data[0]
                ? ((val.data as Rail[])[0]?.data as (
                    | FastEvent
                    | MediaProduction
                  )[])
                : [];
            setItems(items);
            dispatch(updateParams({ items }));
          }
        },
        error: () => {
          console.error('Error recovering content');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };

      if (currentParams?.seasonId) {
        subscription = seasonObservable(
          (currentParams as { seasonId: string })?.seasonId
        ).subscribe(seasonObserver as Partial<Observer<unknown>>);
      } else {
        subscription = mediaProductionObservable(
          (currentParams as { id: string })?.id,
          (currentParams as { seasonNumber: number })?.seasonNumber,
          (currentParams as { isRecord: boolean })?.isRecord
        ).subscribe(seasonObserver as Partial<Observer<unknown>>);
      }
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [complete, initialized, channelsData, currentParams]);

  useEffect(() => {
    if (complete && currentParams?.items) {
      setItems(currentParams?.items as (FastEvent | MediaProduction)[]);
    }
  }, [currentParams]);

  return complete && !currentParams?.rails && !items?.length ? (
    <TEmpty />
  ) : (
    <TMosaic
      data={items}
      flags={{
        complete: complete,
        hasFloatingMenu: true,
        hasDescription: true,
        hasSettings: false,
        startsInMenu: true,
      }}
    />
  );
}
